import React  from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux';
import { AUTHENTICATED_ENTRY } from 'utils/Config'

const PublicRoute = () => {

	const { token } = useSelector(state => state.auth)
	const location = useLocation()

	return token && location.pathname === '/auth/login' ? <Navigate to={AUTHENTICATED_ENTRY} /> : <Outlet/>
}

export default PublicRoute
